if (!customElements.get('pickup-availability')) {
  customElements.define(
    'pickup-availability',
    class PickupAvailability extends HTMLElement {
      constructor() {
        super();
        this.onClickRefreshList = this.onClickRefreshList.bind(this);
      }

      connectedCallback() {
        if (!this.hasAttribute('available')) return;

        this.errorHtml = this.querySelector('template')?.content.firstElementChild.cloneNode(true);
        this.fetchAvailability(this.dataset.variantId);
      }

      fetchAvailability(variantId) {
        let rootUrl = this.dataset.rootUrl;
        if (!rootUrl.endsWith('/')) {
          rootUrl = rootUrl + '/';
        }
        const variantSectionUrl = `${rootUrl}variants/${variantId}/?section_id=pickup-availability`;

        fetch(variantSectionUrl)
          .then((response) => response.text())
          .then((text) => {
            const sectionInnerHTML = new DOMParser()
              .parseFromString(text, 'text/html')
              .querySelector('.shopify-section');
            this.renderPreview(sectionInnerHTML);
          })
          .catch(() => {
            const button = this.querySelector('button');
            if (button) button.removeEventListener('click', this.onClickRefreshList);
            this.renderError();
          });
      }

      onClickRefreshList() {
        this.fetchAvailability(this.dataset.variantId);
      }

      update(variant) {
        if (!variant) {
          this.removeAttribute('available');
          this.innerHTML = '';
          return;
        }

        this.dataset.variantId = variant.id;
        this.setAttribute('available', '');
        this.fetchAvailability(variant.id);
      }

      renderError() {
        if (!this.errorHtml) {
          this.errorHtml = this.querySelector('template')?.content.firstElementChild.cloneNode(true);
        }

        this.innerHTML = '';
        if (this.errorHtml) {
          this.appendChild(this.errorHtml);
        }

        this.querySelector('button')?.addEventListener('click', this.onClickRefreshList);
      }

      applyCustomLabels() {
        const heading = this.dataset.heading;
        const storeDetailsLabel = this.dataset.storeDetailsLabel;
        const checkOtherStoresLabel = this.dataset.checkOtherStoresLabel;

        if (heading) {
          const headingElement = this.querySelector('.pickup-availability-widget__heading-text');
          if (headingElement) headingElement.textContent = heading;
        }

        if (storeDetailsLabel) {
          this.querySelectorAll('.pickup-availability-widget__details-label-text').forEach((element) => {
            element.textContent = storeDetailsLabel;
          });
        }

        if (checkOtherStoresLabel) {
          const footerLink = this.querySelector('.pickup-availability-widget__footer-link-text');
          if (footerLink) footerLink.textContent = checkOtherStoresLabel;
        }
      }

      applyPreviewLimit() {
        const previewCount = parseInt(this.dataset.previewStoresCount, 10) || 5;
        const showFooterLink = this.dataset.showFooterLink !== 'false';
        const items = [...this.querySelectorAll('.pickup-availability-widget__item')];
        const totalCount = items.length;

        items.forEach((item, index) => {
          if (index >= previewCount) item.remove();
        });

        const footer = this.querySelector('.pickup-availability-widget__footer');
        if (footer && (!showFooterLink || totalCount <= 1)) {
          footer.remove();
        }

        this.applyDefaultExpanded();
      }

      applyDefaultExpanded() {
        const items = [...this.querySelectorAll('.pickup-availability-widget__item')];
        if (items.length === 0 || items.length > 2) return;

        items.forEach((item) => {
          const details = item.querySelector('details.pickup-availability-widget__details');
          const info = item.querySelector('.pickup-availability-widget__item-info');
          if (!details) return;

          details.open = true;
          if (info) info.classList.add('active');
        });
      }

      getDrawerModal() {
        return document.getElementById(`PickupAvailabilityDrawer-${this.dataset.widgetId}`);
      }

      syncDrawerControls() {
        const modal = this.getDrawerModal();
        const drawerId = modal?.id;
        if (!modal || !drawerId) return;

        this.querySelectorAll('[aria-controls]').forEach((element) => {
          element.setAttribute('aria-controls', drawerId);
        });
      }

      bindDrawerFooter(modal) {
        if (!modal) return;

        const footerLink = this.querySelector('.pickup-availability-widget__footer-link');
        if (!footerLink) return;

        footerLink.addEventListener('click', (event) => {
          event.preventDefault();
          modal.show(event.currentTarget);
        });
      }

      renderPreview(sectionInnerHTML) {
        if (!sectionInnerHTML?.querySelector('pickup-availability-preview')) {
          this.getDrawerModal()?.hide();
          this.innerHTML = '';
          this.removeAttribute('available');
          return;
        }

        this.innerHTML = sectionInnerHTML.querySelector('pickup-availability-preview').outerHTML;
        this.setAttribute('available', '');

        const modal = this.getDrawerModal();
        const drawerContent = sectionInnerHTML.querySelector('.pickup-availability-drawer-content');

        if (modal && drawerContent) {
          const body = modal.querySelector('[data-pickup-drawer-body]');
          if (body) {
            body.innerHTML = drawerContent.innerHTML;
          }
        }

        this.syncDrawerControls();
        this.bindDrawerFooter(modal);
        this.applyPreviewLimit();
        this.applyCustomLabels();
      }
    }
  );
}
